import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frspace'
})
export class FrenchDecimalPipe implements PipeTransform {

  transform(val:number): string {
    // Format the output to display any way you want here.
    // For instance:
    if (val !== undefined && val !== null) {
      let str = val.toLocaleString('fr')
//       str = str.replace(',', ' ')
      return str
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'frcomma'
})
export class FrenchDecimalPipe2 implements PipeTransform {

  transform(val:number): string {
    // Format the output to display any way you want here.
    // For instance:
    if (val !== undefined && val !== null) {
      let str = val.toLocaleString('fr')
      str = str.replace(',', ' ')
      str = str.replace('.', ',')
      return str
    } else {
      return '';
    }
  }
}
